import React, { useCallback, useContext, useEffect, useState, Suspense } from 'react';
import { withStore } from 'react-context-hook';
import { withCookies } from 'react-cookie';
import Router from './router/router';
import { commonModules } from './common/index';
import Store from './store/store';
import ErrorBoundary from './common/error_boundary/error_boundary';
import './font_library';
import '@patternfly/react-core/dist/styles/base.css';
import './App.scss';

const { UserContext, getCookie, getValue, useLogOut, circularProgress } = commonModules;

const App = (props) => {
  const context = useContext(UserContext),
        { cookies } = props,
        defaultState = {
          loginData: getCookie(cookies, 'stored_login_values') || [],
          canShowLoader: true,
          isLogin: getCookie(cookies, 'is_login') || false,
          //remote_addr: getCookie(cookies, 'remote_addr') || '',
        },
        [dataResponse, setDataResponse] = useState(defaultState),
        { isLogin } = dataResponse,
        { logOutWithoutPopup } = useLogOut(),
        setStateData = useCallback(async (stateName, Fields) => {
          setDataResponse((prevState) => ({
            ...prevState,
            [stateName]: Fields,
          }));
        }, []);

  context.setDataResponse = setStateData;
  context.cookies = cookies;
  context.loginData = { ...dataResponse.loginData };
  // context.publicIp = dataResponse.remote_addr;

  useEffect(() => {
    const handleUserLogout = () => {
      if (!getValue('userLoginData') && window.location.href.indexOf('login') === -1) {
        // Your logout logic here
        logOutWithoutPopup();
      }
    };
    window.addEventListener('storage', handleUserLogout);
    return () => {
      window.removeEventListener('storage', handleUserLogout);
    };
  }, [isLogin]);

  return <ErrorBoundary>
    <Suspense fallback={<div className="mt-3">{circularProgress}</div>}>
      <Store>
        <Router {...context} />
      </Store>
    </Suspense>
  </ErrorBoundary>;
};

export default withCookies(withStore(App));
